export const SearchFilesModal: string = 'SearchFilesModal';
export const WindowWidth: string = '600';
export const WindowHeight: string = '600';
export const WindowLeft: string = '200';
export const WindowTop: string = '200';
